import { HttpErrorResponse, HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class CustomerdosService {

    constructor(private httpService: HttpService, private http: HttpClient) { }
    getallDos(data: any) {

        const url = `${environment.CustomerApiendpoint}/get-all-customer-dos?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getNotImportedOrderList() {
        const url = `${environment.CustomerApiendpoint}/get-not-imported-dos`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getexportFileList() {
        const url = `${environment.CustomerApiendpoint}/get-export-filelist`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallDosFilterData(data: any) {

        const url = `${environment.CustomerApiendpoint}/get-all-customer-dos?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallcity() {
        const url = `${environment.SettingsApiendpoint}/cities?d=all`;
        // const url = `${environment.CustomerApiendpoint}/get-citys`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getallCustomer() {

        const url = `${environment.CustomerApiendpoint}/get-customers`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getSingleCustomer(data) {

        const url = `${environment.CustomerApiendpoint}/get-single-customers/${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    editCustomerDos(data: any, id:any): Observable<any> {
        const url = `${environment.CustomerApiendpoint}/customers/${id}?t=dos`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    getSingleDosData(data: any) {
        const url = `${environment.CustomerApiendpoint}/dos-view/${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteDos(id: any) {
        const url = `${environment.CustomerApiendpoint}/dos-delete/${id}`;

        return this.httpService.delete(url, this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    recommended(id:any,data:any) {
      const url = `${environment.CustomerApiendpoint}/recommended/${id}`;

      return this.httpService.put(url,data, this.httpService.headers)
          .pipe(catchError(this.Errorhandling))
    }
    popular(id: any,data:any) {
      const url = `${environment.CustomerApiendpoint}/popular/${id}`;

      return this.httpService.put(url,data,this.httpService.headers)
          .pipe(catchError(this.Errorhandling))
    }
    postCustomerDos(data: any) {

        const url = `${environment.CustomerApiendpoint}/add-dos?t=dos`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    updateStatus(id: any, status: any): Observable<any> {
        const url = `${environment.CustomerApiendpoint}/dos-status/${id}/${status}`
        return this.httpService.put(url, {}, this.httpService.headers)
    }

    checkTestCode(data){
        const url = `${environment.SettingsApiendpoint}/listByTestCode`;
        return this.httpService.post(url,data,this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    downloadDos(data: any) {
        const url = `${environment.CustomerApiendpoint}/export-dos`;

        return this.httpService.post(url, data, this.httpService.headers);

    }

    uploadFile(data:any, imagefile: File) {
        const url = `${environment.CustomerApiendpoint}/import-dos`;
        const formData = new FormData();
        formData.append('file', imagefile);
            formData.append('customer_id',data.customer_id);
            formData.append('provider_id',data.provider_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }
    uploadTestParemFile(data:any, imagefile: File) {
        const url = `${environment.CustomerApiendpoint}/import_test_paremeter`;
        const formData = new FormData();
        formData.append('file', imagefile);
            formData.append('customer_id',data.customer_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
